import { useCallback, useState } from 'react';

import Box from '@mui/material/Box';

import { useCheckout } from '../../../../hooks/use-checkout';
import { OrDivider } from './components/OrDivider/OrDivider';
import { ExpressCheckoutProps } from './ExpressCheckout.types';
import { usePaymentState } from '../../hooks/use-payment-state';
import { useAppConfig } from '../../../../hooks/use-app-config';
import { mobileSDKUtils } from '../../../../utils/mobile-sdk-utils';
import { getIsSupercellTemplate } from '../../../../utils/get-is-supercell-template';
import { useShouldBlockExpressCheckoutButtons } from './hooks/use-should-block-express-chekcout-buttons';
import { ExpressComponentsRenderer } from './components/ExpressComponentsRenderer/ExpressComponentsRenderer';

const isMobileSdk = mobileSDKUtils.isMobileSdk();

const IS_SUPERCELL_TEMPLATE = getIsSupercellTemplate();

export function ExpressCheckout({ onDisabledButtonClicked }: ExpressCheckoutProps) {
  const { checkoutData } = useCheckout();
  const { featureFlags } = useAppConfig();
  const [isComponentsAvailable, setIsComponentsAvailable] = useState(false);
  const isPaymentLoading = usePaymentState((state) => state.isPaymentLoading);
  const { shouldBlockExpressCheckoutButtons } = useShouldBlockExpressCheckoutButtons();

  const onComponentsReady = useCallback((isComponentsAvailable: boolean) => {
    setIsComponentsAvailable(isComponentsAvailable);
  }, []);

  const showExpressDivider =
    isComponentsAvailable && (isMobileSdk || featureFlags?.checkout_payment_methods_divider);
  const paymentMethods = checkoutData?.paymentMethods;

  return (
    <Box
      style={{
        pointerEvents: isPaymentLoading ? 'none' : 'auto',
        marginTop: IS_SUPERCELL_TEMPLATE ? '0' : '1em',
      }}
      position={'relative'}
    >
      {shouldBlockExpressCheckoutButtons && (
        <Box
          position={'absolute'}
          onClick={onDisabledButtonClicked}
          width={'100%'}
          height={'100%'}
          zIndex={999999}
        />
      )}
      <ExpressComponentsRenderer
        paymentMethods={paymentMethods}
        onComponentsReady={onComponentsReady}
      />
      {showExpressDivider && <OrDivider />}
    </Box>
  );
}
